<div id="transaction-details-section">
  <span id="subtitle">{{ pageHeader }}</span>
  <a *ngIf="(createRequestStep$ | async) === 'review'  && !isInrFromTable" class="no-print" id="edit-link" (click)="onEditClicked()">Edit</a>
  <div id="resp-table">
    <div id="resp-table-body">
      <div class="resp-table-row">
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_transactionType" data-testid="wireDetails_transactionType" class="loa loaSubmitDetails"
              data-loafieldname="{{pdfLabelsSubmitDetails.transactionType}}" [title]="labels.transactionType"
              [data]="transactionTypeLabel" data-testid="wireDetails_transactionType">
          </mm-label-group>
        </div>
        <div *ngIf="!isStandingAuthViewPage && !isViewTemplate" [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_standingAuth"   data-testid="wireDetails_standingAuth"
                      [title]="labels.useStandingAuth" [data]="useStandingAuth | titlecase">
        </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" *ngIf="useStandingAuth === 'yes'">
          <mm-label-group 
                      id="wireDetails_standingAuthDetails" data-testid="wireDetails_standingAuthDetails"
                      [title]="isBundledStandingAuthTransaction ? labels.bundledStandingAuthDetails : labels.standingAuthDetails"
                      [multilineData]="standingAuthDetails">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_isThereAnIntermediaryInstitution"
                      data-testid="wireDetails_isThereAnIntermediaryInstitutionHorizontalLabel"
                      [title]="labels.isThereAnIntermediaryInstitutionHorizontalLabel" [data]="intermediarySelection | titlecase">
          </mm-label-group>
        </div>
      </div>
      <div class="dashed-border"></div>
      <!-- Intermediary 'no' & 'third party' -->
      <div class="resp-table-row" *ngIf="!isFirstParty && intermediarySelection === 'no'">
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_aba" class="column loa "
                        data-loafieldname="{{pdfLabelsToDetails.receivingBankAbaNumber}}" data-testid="wireDetails_aba"
                        [title]="labels.abaNumber" [data]="transactionDetails.aba">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" class="schwab-grey padding-y-0"  id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="!isViewPage && (transactionDetails.receivingBankClearingSysId !=null && receivingBankClearingSysId && !isIdentifierAba); else elseBlock">
          <span id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="transactionDetails.receivingBankClearingSysId != null && receivingBankClearingSysId && !isIdentifierAba">
            <mm-label-group id="wireDetails_clearingSysId" data-testid="wireDetails_clearingSysId"
            [title]="labels.clearingSystemId" class="loa "[data]="transactionDetails.receivingBankClearingSysId">
          </mm-label-group>
          </span>
        </div>
        <ng-template #elseBlock>
          <span [ngClass]="useFiveColumns ? 'table-body-cell-20' : 'table-body-cell' "  class="schwab-grey padding-y-0"  id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="receivingBankClearingSysId && !isIdentifierAba">
          <mm-label-group id="wireDetails_clearingSysId" data-testid="wireDetails_clearingSysId"
            [title]="labels.clearingSystemId" class="loa " [data]="receivingBankClearingSysId">
          </mm-label-group>
        </span>
        </ng-template>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" style="white-space: pre-line;">
          <mm-label-group id="wireDetails_bankDetails" data-testid="wireDetails_bankDetails" [title]="labels.intermediaryBankInformation"
                          [multilineData]="receivingBankDetails">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" *ngIf="!isStandingAuthViewPage && isViewPage">
          <mm-label-group id="wireDetails_referenceNumber" data-testid="wireDetails_refNum"
                          [title]="labelRefNum" [data]="refNum">
          </mm-label-group>
        </div>
      </div>
      <div *ngIf="!isFirstParty && intermediarySelection === 'no'">
        <div class="dashed-border"></div>
        <div class="resp-table-row">
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" *ngIf="!isIrsAba">
            <mm-label-group id="wireDetails_receivingBankAccountNumber"
              data-loafieldname="{{pdfLabelsToDetails.beneficiaryAccountNumber}}"
              data-testid="wireDetails_receivingBankAccountNumber" class="loa "
              [title]="isoReceivingBankAccountNumber" [data]="transactionDetails.toAccount">
            </mm-label-group>
          </div>
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group class="white-space" id="wireDetails_recepientName" data-testid="wireDetails_recepientName"
              [title]="labels.recipientName" [multilineData]="recipientName">
            </mm-label-group>
          </div>
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group id="wireDetails_recepientAddress" data-testid="wireDetails_recepientAddress" class="white-space"
              [title]="labels.recipientAddress" [multilineData]="recipientAddress">
            </mm-label-group>
          </div>
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group id="wireDetails_recipient" data-testid="wireDetails_recipient_horizontalLabel"
              [title]="labels.recipientHorizontalLabel" [data]="recipient">
            </mm-label-group>
          </div>
        </div>
        <!--IsIrsAba-->
        <div *ngIf="isIrsAba">
          <div class="dashed-border"></div>
          <div class="resp-table-row" >
            <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
              <mm-label-group id="wireDetails_taxPayerId" data-testid="wireDetails_taxPayerId"
                [title]="labels.taxPayerId" [data]="isViewPage ? (taxPayerId | maskAccountNumber) : (transactionDetails.taxPayerId | maskAccountNumber)" 
                class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.taxId}}">
              </mm-label-group>
            </div>
            <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
              <mm-label-group class="white-space" id="wireDetails_taxTypeCode" data-testid="wireDetails_taxTypeCode"
                [title]="labels.taxTypeCode" [data]="isViewPage ? taxTypeCode : transactionDetails.taxTypeCode"
                class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.taxTypeCode}}">
              </mm-label-group>
            </div>
            <div *ngIf="!isStandingAuthViewPage" [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
              <mm-label-group id="wireDetails_taxYear" data-testid="wireDetails_taxYear"
                [title]="labels.taxYear" [data]="isViewPage ? taxYear : transactionDetails.taxYear"
                class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.taxYear}}">
              </mm-label-group>
            </div>
            <div *ngIf="!isStandingAuthViewPage" [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
              <mm-label-group id="wireDetails_taxMonth" data-testid="wireDetails_taxMonth" class="white-space"
                [title]="labels.taxMonth" [data]="isViewPage ? taxMonthCode : taxMonth"
                class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.taxMonth}}">
              </mm-label-group>
            </div>
          </div>
        </div>
      </div>
      <!-- Intermediary 'yes' & 'third party' -->
      <div *ngIf="intermediarySelection === 'yes'">
        <div id="resp-table">
          <div id="resp-table-body">
            <div class="resp-table-row">
              <span [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" class="schwab-grey font-bold padding-y-0" id="intermediary-sloa" data-testid="intermediary-input-sloa">
                Intermediary
              </span>
              <span [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" class="schwab-grey padding-y-0" id="bank-aba-sloa" data-testid="bank-aba-input-sloa" *ngIf="transactionDetails.aba">
                <mm-label-group id="wireDetails_aba" class="column loa "
                          data-loafieldname="{{pdfLabelsToDetails.receivingBankAbaNumber}}" data-testid="wireDetails_aba"
                          [title]="labels.abaNumber" [data]="transactionDetails.aba">
                </mm-label-group>
              </span>
              <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell' " class="schwab-grey padding-y-0" *ngIf="!isViewPage && (transactionDetails.receivingBankClearingSysId !=null && receivingBankClearingSysId && !isIdentifierAba); else elseBlock" >
                    <span id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="transactionDetails.receivingBankClearingSysId != null && receivingBankClearingSysId && !isIdentifierAba">
                <mm-label-group id="wireDetails_clearingSysId" data-testid="wireDetails_clearingSysId"
                  [title]="labels.clearingSystemId" class="loa " [data]="transactionDetails.receivingBankClearingSysId">
                </mm-label-group>
              </span>
              </div>
              <ng-template #elseBlock>
          <span [ngClass]="useFiveColumns ? 'table-body-cell-20' : 'table-body-cell' "  class="schwab-grey padding-y-0"  id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="receivingBankClearingSysId && !isIdentifierAba">
          <mm-label-group id="wireDetails_clearingSysId" data-testid="wireDetails_clearingSysId"
            [title]="labels.clearingSystemId" class="loa " [data]="receivingBankClearingSysId">
          </mm-label-group>
        </span>
        </ng-template>
              
              <span [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
                <mm-label-group id="wireDetails_bankDetails" data-testid="wireDetails_bankDetails" [title]="labels.intermediaryBankInformation"
                                [multilineData]="receivingBankDetails">
                </mm-label-group>
              </span>
              <span [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" *ngIf="!isStandingAuthViewPage && isViewPage">
                <mm-label-group id="wireDetails_referenceNumber" data-testid="wireDetails_refNum"
                  [title]="labelRefNum" [data]="refNum">
                </mm-label-group>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="(useSloa || isViewPage) && intermediarySelection === 'yes'">
        <!-- Second Intermediary start-->
        <div id="resp-table" class="padding-y-16" *ngIf="isThreeStep || isFourStep">
          <div id="resp-table-body">
              <div class="resp-table-row">
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey font-bold">
                  Second Intermediary
              </span>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="secondIntermediaryAccountNumber" data-testid="second-intermediary-account-number-label">
                  {{useSloaSecondIntermediaryAccountNumberLabel}}
              </label>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="secondIntermediaryBIC">
                  Business ID code (BIC)
              </label>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="secondIntermediaryClearingSysId">
                  Clearing system ID
              </label>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey">
                  Bank information
              </label>
              </div>
              <div class="resp-table-row">
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0">
                  
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="secondIntermediaryAccountNumber">
                  {{secondIntermediaryAccountNumber}}
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="secondIntermediaryBIC">
                  {{secondIntermediaryBIC}}
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="secondIntermediaryClearingSysId">
                  {{secondIntermediaryClearingSysId}}
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" style="white-space: pre-line;">
                  {{secondIntermediaryDetails}}
              </span>
              </div>
          </div>
        </div>
        <!--Second Intermediary end-->
        <!-- Third Intermediary start-->
        <div id="resp-table" class="padding-y-16" *ngIf="isFourStep">
          <div id="resp-table-body">
              <div class="resp-table-row">
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey font-bold">
                  Third Intermediary
              </span>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="thirdIntermediaryAccountNumber" data-testid="third-intermediary-account-number-label">
                  {{useSloaThirdIntermediaryAccountNumberLabel}}
              </label>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="thirdIntermediaryBIC">
                  Business ID code (BIC)
              </label>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="thirdIntermediaryClearingSysId">
                  Clearing system ID
              </label>
              <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey">
                  Bank information
              </label>
              </div>
              <div class="resp-table-row">
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0">
                  
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="thirdIntermediaryAccountNumber">
                  {{thirdIntermediaryAccountNumber}}
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="thirdIntermediaryBIC">
                  {{thirdIntermediaryBIC}}
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="thirdIntermediaryClearingSysId">
                  {{thirdIntermediaryClearingSysId}}
              </span>
              <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" style="white-space: pre-line;">
                  {{thirdIntermediaryDetails}}
              </span>
              </div>
          </div>
        </div>
        <!--Third Intermediary end-->
      </div>
      <div *ngIf="intermediarySelection === 'yes'" id="resp-table">
        <div id="resp-table-body">
            <div class="resp-table-row">
            <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey font-bold">
                Recipient bank
            </span>
            <label id="wireDetails_intermediaryAccountNumberHorizontalLabel_label" data-testid="wireDetails_intermediaryAccountNumberHorizontalLabel_label" [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="intermediaryAccountNumber">
                {{useSloaIntermediaryAccountNumberLabel}}
            </label>
            <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="intermediaryBIC">
                Business ID code (BIC)
            </label>
            <label [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey" *ngIf="intermediaryClearingSysId">
                Clearing system ID
            </label>
            <label data-testid="wireDetails_intermediaryDetails_label" id="wireDetails_intermediaryDetails_label" [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="padding-y-0 schwab-grey">
                Bank information
            </label>
            </div>
            <div class="resp-table-row">
            <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0">
                
            </span>
            <span id="wireDetails_intermediaryAccountNumberHorizontalLabel" data-testid="wireDetails_intermediaryAccountNumberHorizontalLabel" [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="intermediaryAccountNumber">
                {{intermediaryAccountNumber}}
            </span>
            <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="intermediaryBIC">
                {{intermediaryBIC}}
            </span>
            <span [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" *ngIf="intermediaryClearingSysId">
                {{intermediaryClearingSysId}}
            </span>
            <span data-testid="wireDetails_intermediaryDetails" id="wireDetails_intermediaryDetails" [ngClass]="useFiveColumns && (useSloa || isViewPage) ? 'table-body-cell-20' : 'table-body-cell'" class="font-arial padding-y-0" style="white-space: pre-line;">
                {{intermediaryDetails}}
            </span>
            </div>
        </div>
      </div>
      <div *ngIf="intermediarySelection === 'yes'" class="dashed-border"></div>
      <div class="resp-table-row" *ngIf="intermediarySelection === 'yes'">
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_receivingBankAccountNumber"
            data-loafieldname="{{pdfLabelsToDetails.beneficiaryAccountNumber}}"
            data-testid="wireDetails_receivingBankAccountNumber" class="loa "
            [title]="isoReceivingBankAccountNumber" [data]="transactionDetails.toAccount">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group class ="white-space" id="wireDetails_recepientName" data-testid="wireDetails_recepientName"
            [title]="labels.recipientName" [multilineData]="recipientName">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_recepientAddress" data-testid="wireDetails_recepientAddress" class ="white-space"
            [title]="labels.recipientAddress" [multilineData]="recipientAddress">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_recipient" data-testid="wireDetails_recipient_horizontalLabel"
            [title]="labels.recipientHorizontalLabel" [data]="recipient">
          </mm-label-group>
        </div>
      </div>

      <!-- Intermediary 'no' & 'first party' -->
      <div class="resp-table-row" *ngIf="isFirstParty && intermediarySelection === 'no'">
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_aba" class="column loa "
                        data-loafieldname="{{pdfLabelsToDetails.receivingBankAbaNumber}}" data-testid="wireDetails_aba"
                        [title]="labels.abaNumber" [data]="transactionDetails.aba">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell' " class="schwab-grey padding-y-0" *ngIf="!isViewPage && (transactionDetails.receivingBankClearingSysId !=null && receivingBankClearingSysId && !isIdentifierAba); else elseBlock" >
          <div id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="transactionDetails.receivingBankClearingSysId !=null && receivingBankClearingSysId && !isIdentifierAba">
          <mm-label-group id="wireDetails_clearingSysId" data-testid="wireDetails_clearingSysId"
            [title]="labels.clearingSystemId" class="loa" [data]="transactionDetails.receivingBankClearingSysId">
          </mm-label-group>
           </div>
        </div>
        <ng-template #elseBlock>
          <div [ngClass]="useFiveColumns ? 'table-body-cell-20' : 'table-body-cell' " class="schwab-grey padding-y-0"  id="wireDetails_clearingSysId-container" data-testid="wireDetails_clearingSysId-container" *ngIf="receivingBankClearingSysId && !isIdentifierAba">
          <mm-label-group id="wireDetails_clearingSysId" data-testid="wireDetails_clearingSysId"
            [title]="labels.clearingSystemId" class="loa " [data]="receivingBankClearingSysId">
          </mm-label-group>
        </div>
        </ng-template>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_bankDetails" data-testid="wireDetails_bankDetails" [title]="labels.intermediaryBankInformation"
                          [multilineData]="receivingBankDetails">
          </mm-label-group>
        </div>
        <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'" *ngIf="!isStandingAuthViewPage && isViewPage">
          <mm-label-group id="wireDetails_referenceNumber" data-testid="wireDetails_refNum"
                          [title]="labelRefNum" [data]="refNum">
          </mm-label-group>
        </div>
        
      </div>
      <div *ngIf="isFirstParty && intermediarySelection === 'no'">
        <div class="dashed-border"></div>
        <div class="resp-table-row">
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group id="wireDetails_receivingBankAccountNumber"
              data-loafieldname="{{pdfLabelsToDetails.beneficiaryAccountNumber}}"
              data-testid="wireDetails_receivingBankAccountNumber" class="loa "
              [title]="isoReceivingBankAccountNumber" [data]="transactionDetails.toAccount">
            </mm-label-group>
          </div>
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group class="white-space" id="wireDetails_recepientName" data-testid="wireDetails_recepientName"
              [title]="labels.recipientName" [multilineData]="recipientName">
            </mm-label-group>
          </div>
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group class="white-space" id="wireDetails_receivingAccountHolder"
              data-testid="wireDetails_receivingAccountHolder" [title]="labels.recipientAddress"
              [multilineData]="receivingAccountHolder">
            </mm-label-group>
          </div>
          <div [ngClass]="useFiveColumns && useSloa ? 'table-body-cell-20' : 'table-body-cell'">
            <mm-label-group id="wireDetails_recipient" data-testid="wireDetails_recipient"
              [title]="labels.recipientHorizontalLabel" [data]="recipient">
            </mm-label-group>
          </div>
        </div>
      </div> 
      <div *ngIf="!isStandingAuthViewPage" class="dashed-border"></div>
      <div *ngIf="isStandingAuthViewPage && isIra" class="dashed-border"></div>
    </div>
  </div>
  <div id="resp-table">
    <div id="resp-table-body">
      <div class="resp-table-row">
        <div class="table-body-cell">
          <mm-label-group *ngIf="!isStandingAuthViewPage && !isViewTemplate" id="wireDetails_ProcessDate"
              class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.processDate}}" 
              data-testid="wireDetails_ProcessDate" [title]="labels.processDate" [data]="formattedSelectDate">
          </mm-label-group>
        </div>
        <div class="table-body-cell" *ngIf="(createRequestStep$ | async) === 'confirmation'">
          <mm-label-group id="wireDetails-confirmation-refNum" data-testid="wireDetails-confirmation-refNum"
            [title]="labelRefNum" [data]="refNum">
          </mm-label-group>
        </div>
      </div>

      <div *ngIf="(createRequestStep$ | async) === 'review' || (createRequestStep$ | async) === 'confirmation'"
      class="label-group" id="wire_disclaimer">
      <span id="tax-copy-paragraph-one">{{ wireDisclaimer }}</span>
      </div>

      <div *ngIf="(createRequestStep$ | async) === 'confirmation'" class="label-group" id="wire_disclaimer">
        <span>{{ federalReferenceNumberDisclaimer }}</span>
      </div>

      <div *ngIf="!isStandingAuthViewPage" class="resp-table-row">
        <div [ngClass]="showForeignCurrencyFields ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_amount" data-testid="wireDetails_amount"
            data-loafieldname="{{pdfLabelsSubmitDetails.wireAmount}}" class="column loa loaSubmitDetails"
            [title]="showForeignCurrencyFields ? labels.wireAmountUS : labels.wireAmount" [data]="wireAmount">
          </mm-label-group>
        </div>
        <!-- Begin foreign currency fields -->
        <div *ngIf="showForeignCurrencyFields" class="table-body-cell-20">
          <mm-label-group id="wireDetails_foreignCurrencyAmount" data-testid="wireDetails_foreignCurrencyAmount"
          [title]="labels.foreignCurrencyAmount" [data]="currencyAmount"></mm-label-group>
        </div>
        <div *ngIf="showForeignCurrencyFields" class="table-body-cell-20">
          <mm-label-group id="wireDetails_currency" data-testid="wireDetails_currency"
          [title]="labels.currency" [data]="currencyType"></mm-label-group>
        </div>
        <div *ngIf="showForeignCurrencyFields" class="table-body-cell-20">
          <mm-label-group id="wireDetails_exchangeRate" data-testid="wireDetails_exchangeRate"
          [title]="labels.exchangeRate" [data]="exchangeRate"></mm-label-group>
        </div>
        <!-- End foreign currency fields -->
        <div *ngIf="isIra && !isViewPage" class="table-body-cell">
          <mm-label-group id="amount-type" data-testid="wireDetails_amountType" class="column"
            [title]="labels.grossNet" [data]="transactionDetails.amountType | titlecase">
          </mm-label-group>
        </div>
        <div *ngIf="!isStandingAuthViewPage && !isViewTemplate" [ngClass]="showForeignCurrencyFields ? 'table-body-cell-20' : 'table-body-cell'">
          <mm-label-group id="wireDetails_fee" data-testid="wireDetails_fee"
            data-loafieldname="{{pdfLabelsSubmitDetails.wireFee}}" class="column loa loaSubmitDetails"
            [title]="labels.wireFee" [data]="wireFee">
          </mm-label-group>
        </div>
      </div>
      <!-- Begin tax details -->
      <div *ngIf="isIra && !isViewTemplate && !isStandingAuthViewPage" class="resp-table-row">
        <div class="table-body-cell">
          <mm-label-group id="federal-tax-percentage"
            data-loafieldname="{{pdfLabelsSubmitDetails.fedTax}}" class="column loa loaSubmitDetails"
            data-testid="wireDetails_federalTaxPercent" [title]="labels.federalTax" [data]="fedTaxPercent">
          </mm-label-group>
        </div>
        <div class="table-body-cell">
          <mm-label-group *ngIf="!isStandingAuthViewPage" id="federal-tax-amount" data-testid="wireDetails_federalTaxAmount"
            [title]="labels.federalTaxAmount" [data]="fedTaxAmount">
          </mm-label-group>
        </div>
      </div>
      <div *ngIf="isIra && !isViewTemplate && !isStandingAuthViewPage" class="resp-table-row">
        <div class="table-body-cell">
          <mm-label-group *ngIf="stateTaxPercent" id="state-tax-percentage" data-loafieldname="{{pdfLabelsSubmitDetails.stateTax}}"
            data-testid="wireDetails_stateTaxPercent" class="column loa loaSubmitDetails" [title]="stateTaxLabel" [data]="stateTaxPercent">
          </mm-label-group>
        </div>
        <div class="table-body-cell">
          <mm-label-group *ngIf="!isStandingAuthViewPage" id="state-tax-amount" data-testid="wireDetails_stateTaxAmount"
            [title]="labels.stateTaxAmount" [data]="stateTaxAmount">
          </mm-label-group>
        </div>
      </div>
      <div *ngIf="isIra && !isViewTemplate && !isStandingAuthViewPage" class="resp-table-row">
        <div class="table-body-cell"></div>
        <div class="table-body-cell">
          <mm-label-group id="wire-amount-with-taxes" data-testid="wireDetails_wireAmountWithTaxes"
            data-loafieldname="{{amountIncludingTaxesLabel}}" [title]="amountIncludingTaxesLabel" [data]="(amountIncludingTaxes | currency)!">
          </mm-label-group>
        </div>
      </div>
      <!-- End tax details -->
    </div>
  </div>

  <div *ngIf="!isViewTemplate && isStandingAuthViewPage" class="resp-table">
    <div class="resp-table-body">
      <!-- Begin Tax Fields for Standing Auth View Page -->
      <div *ngIf="isIra" class="table-body-cell">
        <mm-label-group id="federal-tax-percentage" data-loafieldname="{{pdfLabelsSubmitDetails.fedTax}}"
          data-testid="wireDetails_federalTaxPercent" class="column loa loaSubmitDetails" [title]="labels.federalTax"
          [data]="fedTaxPercent">
        </mm-label-group>
      </div>
      <div *ngIf="isIra && stateTaxPercent" class="table-body-cell">
        <mm-label-group id="state-tax-percentage"
          data-loafieldname="{{pdfLabelsSubmitDetails.stateTax}}" data-testid="wireDetails_stateTaxPercent"
          class="column loa loaSubmitDetails" [title]="stateTaxLabel" [data]="stateTaxPercent">
        </mm-label-group>
      </div>
      <!-- End Tax Fields for Standing Auth View Page -->
      <!-- Begin Foreign Currency Fields for Standing Auth View Page -->
      <div *ngIf="showForeignCurrencyFields" class="table-body-cell">
        <mm-label-group id="wireDetails_currency_standingAuth" data-testid="wireDetails_currency_standingAuth"
        [title]="labels.currency" [data]="currencyType"></mm-label-group>
      </div>
      <!-- End Foreign Currency Fields for Standing Auth View Page -->
    </div>
  </div>
  <div >

  <div *ngIf="!isStandingAuthViewPage && !isViewTemplate" class="row">
    <mm-label-group id="wireDetails_withdrawalAmount" data-loafieldname="{{pdfLabelsSubmitDetails.withdrawalAmount}}"
                    data-testid="wireDetails_withdrawalAmount" class="column loa loaSubmitDetails"
                    [title]="labels.totalWithdrawalAmount" [data]="(totalWithdrawalAmount | currency)!">
    </mm-label-group>
  </div>

  <div *ngIf="isIra && !isStandingAuthViewPage && !isViewTemplate" class="row">
    <mm-label-group id="distribution-reason" data-loafieldname="{{pdfLabelsSubmitDetails.distributionReason}}"
                    data-testid="wireDetails_distributionReason" class="column loa loaSubmitDetails"
                    [title]="labels.distributionReason" [data]="distributionReason">
    </mm-label-group>
  </div>
  
  <div *ngIf="isPtrs && (trustIncmPct || trustPrinPct)" class="row">
    <mm-label-group id="income-percentage" class="column" data-testid="wireDetails_incomePercentage"
                    [title]="labels.trustIncomePercent" [data]="trustIncmPct" *ngIf="trustIncmPct">
    </mm-label-group>

    <mm-label-group id="principal-percentage" class="column" data-testid="wireDetails_principalPercentage"
                    [title]="labels.trustPrincipalPercent" [data]="trustPrinPct" *ngIf="trustPrinPct">
    </mm-label-group>
  </div>

  <div *ngIf="isPtrs && trustTaxCat" class="row">
    <mm-label-group id="trust-tax-category" class="column" data-testid="wireDetails_trustTaxCategory"
                    [title]="labels.trustTaxCategory" [data]="trustTaxCat">
    </mm-label-group>
  </div>

  <div *ngIf="isPtrs && trustTaxCode" class="row">
    <mm-label-group id="trust-tax-code" class="column" data-testid="wireDetails_trustTaxCode"
                    [title]="labels.trustTaxCode" [data]="trustTaxCode">
    </mm-label-group>
  </div>

  <div *ngIf="isPtrs && paidFor" class="row">
    <mm-label-group id="paid-for" class="column" data-testid="wireDetails_paidFor" [title]="labels.trustPaidFor"
                    [data]="paidFor">
    </mm-label-group>
  </div>

  <div *ngIf="isPtrs && isNotEmptyOrNull(tranMemo)" class="row">
    <mm-label-group id="trust-comment" class="column" data-testid="wireDetails_trustComment"
                    [title]="labels.trustComment" [data]="tranMemo">
    </mm-label-group>
  </div>

  <sdps-divider *ngIf="transactionDetails.transmissionNotes || transactionDetails.remittanceInformation || irsAdditionalInfo" variation="secondary"></sdps-divider>

  <div class="resp-table">
    <div class="resp-table-body">
      <!-- Optional remittance information for international wires -->
      <div *ngIf="transactionDetails.remittanceInformation" class="table-body-cell">
        <mm-label-group id="wireDetails_remittanceInformation"
          data-testid="wireDetails_remittanceInformation" class="column"
          [title]="labels.remittanceInformation" [data]="transactionDetails.remittanceInformation">
        </mm-label-group>
      </div>
      <div *ngIf="transactionDetails.transmissionNotes" class="table-body-cell width-100">
        <mm-label-group id="wireDetails_transmissionNotes"
          data-loafieldname="{{pdfTransmissionNotesLoa}}"
          data-testid="wireDetails_transmissionNotes" class="column loa loaSubmitDetails"
          [title]="transmissionNotesLabel" [data]="transactionDetails.transmissionNotes">
        </mm-label-group>
      </div>
      <div *ngIf="irsAdditionalInfo && isViewPage && isIrsAba" class="table-body-cell width-100">
        <mm-label-group id="irsAdditionalInfo"
          data-loafieldname="{{pdfTransmissionNotesLoa}}"
          data-testid="wireDetails_irsAdditionalInfo" class="column loa loaSubmitDetails"
          [title]="transmissionNotesLabel" [data]="irsAdditionalInfo">
        </mm-label-group>
      </div>
    </div>
  </div>

  <div *ngIf="!!palAgreementAcknowledgement && ((createRequestStep$ | async) === 'review' || (createRequestStep$ | async) === 'confirmation')"
    id="pal-attestation-section"
    data-testid="pal-attestation-section"
    class="pal-attestation-section">
    <sdps-divider variation="secondary"></sdps-divider>
    <h2 id="pal-attestation-subtitle">Line of credit acknowledgement</h2>
    <div class="pal-attestation-box">
      <div class="row">
        <div class="col-1">
          <input type="checkbox" checked disabled id="palAgreementCheckbox" class="pal-checkbox">
        </div>
        <div class="col-2">
          <label for="palAgreementCheckbox">{{ palAgreementAcknowledgement }}</label>
        </div>
      </div>
      <ul class="pal-attestation-list">
        <li *ngFor="let item of palAgreementItems">{{ item }}</li>
      </ul>
    </div>
  </div>

  <div *ngIf="isIra && (createRequestStep$ | async) === 'review'" class="row small-bottom-spacer">
    <mm-label-group data-testid="tax-paragraph-one" [data]="taxParagraphOne">{{ taxParagraphOne }}</mm-label-group>
  </div>

  <div *ngIf="isIra && (createRequestStep$ | async) === 'review'" class="row medium-bottom-spacer">
    <mm-label-group data-testid="tax-paragraph-two" [data]="taxParagraphTwo">{{ taxParagraphTwo }}</mm-label-group>
  </div>

  <mm-banners *ngIf="isPtrs && isViewPage" [bannerText]="[viewPagePtrsInfoBannerPrimaryText]"
              [boldText]="viewPagePtrsInfoBannerBoldText" [type]="'information'" id="wireDetails_ptrsDisclaimer" [showCloseIcon]="false"
              data-testid="wireDetails_ptrsDisclaimer"></mm-banners>

  </div>
</div>

